import { useState } from 'react';
import NotificationPanel from './NotificationPanel';
import NotificationDetails from './NotifictionDetails';

const userInfo = [
  {
    id: 0,
    title: 'মোঃ আক্তার হোসেন',
    subtitle: 'Leave Request',
    subtitle2: '5 min ago',
    badge: {
      label: 'In Progress',
    },
  },
  {
    id: 1,
    title: 'মোহাম্মদ মঈনউদ্দীন আবদুল্লাহ',
    subtitle: 'Transfer Request',
    subtitle2: '5 min ago',
    badge: {
      label: 'In Progress',
    },
  },
  {
    id: 2,
    title: 'মোঃ জহুরুল হক',
    subtitle: 'Leave Request',
    subtitle2: '5 min ago',
    badge: {
      label: 'In Progress',
    },
  },
  {
    id: 3,
    title: 'মোহাম্মদ মঈনউদ্দীন আবদুল্লাহ',
    subtitle: 'Transfer Request',
    subtitle2: '5 min ago',
    badge: {
      label: 'In Progress',
    },
  },
  {
    id: 4,
    title: 'মোছাঃ আছিয়া খাতুন',
    subtitle: 'Promotion Request',
    subtitle2: '5 min ago',
    badge: {
      label: 'In Progress',
    },
  },
  {
    id: 5,
    title: 'মোঃ জাকির হোসেন',
    subtitle: 'Leave Request',
    subtitle2: '5 min ago',
    badge: {
      label: 'In Progress',
    },
  },
  {
    id: 6,
    title: 'মোঃ রেজানুর রহমান',
    subtitle: 'Retirement Request',
    subtitle2: '5 min ago',
    badge: {
      label: 'In Progress',
    },
  },
];
const Notifications = () => {
  const [selected, setSelected] = useState<any>();
  const handleSelected = (id: any) => {
    setSelected(userInfo[id]);
  };
  return (
    <div className="row g-0 w-100 p-10">
      <div className="col-xl-4 w-100">
        <NotificationPanel
          userInfo={userInfo}
          handleSelected={handleSelected}
          selected={selected}
        />
      </div>
      {selected && (
        <div className="col-xl-8 w-100">
          <NotificationDetails selected={selected} />
        </div>
      )}
    </div>
  );
};
export default Notifications;
